<app-admin-page-header
  eyebrow="Tableau de bord"
  [title]="greetingFor(currentUser$ | async)"
  subtitle="Aperçu de l'activité du groupe et accès rapide à la gestion du site.">
  <a routerLink="/admin/evenements"
    class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
    </svg>
    Nouvel événement
  </a>
</app-admin-page-header>

<!-- KPI cards -->
<div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between mb-3">
      <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
        <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
        </svg>
      </div>
      <span class="text-[10px] uppercase tracking-wider font-semibold text-gray-400">Membres</span>
    </div>
    <p class="text-3xl font-alice text-blue-dark">{{ nbMembresInscrits }}</p>
    <p class="text-xs text-gray-500 mt-1 font-raleway">Inscrits sur le site</p>
  </div>

  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between mb-3">
      <div class="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
        <svg class="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
      </div>
      <span class="text-[10px] uppercase tracking-wider font-semibold text-gray-400">{{ nbEvenementsAVenir }} à venir</span>
    </div>
    <p class="text-3xl font-alice text-blue-dark">{{ nbSortieAnnee }}</p>
    <p class="text-xs text-gray-500 mt-1 font-raleway">Sorties cette année</p>
  </div>

  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between mb-3">
      <div class="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
        <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/>
        </svg>
      </div>
      <span class="text-[10px] uppercase tracking-wider font-semibold text-gray-400">Actualités</span>
    </div>
    <p class="text-3xl font-alice text-blue-dark">{{ nbActualites }}</p>
    <p class="text-xs text-gray-500 mt-1 font-raleway">Articles publiés</p>
  </div>

  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between mb-3">
      <div class="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
        <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
        </svg>
      </div>
      <span class="text-[10px] uppercase tracking-wider font-semibold text-gray-400">Ressources</span>
    </div>
    <p class="text-3xl font-alice text-blue-dark">{{ nbRessources }}</p>
    <p class="text-xs text-gray-500 mt-1 font-raleway">Partitions, audio, PDF...</p>
  </div>
</div>

<!-- Next event hero + chart -->
<div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
  <!-- Prochaine sortie -->
  <div class="lg:col-span-2 relative rounded-xl overflow-hidden border border-gray-200 shadow-sm min-h-[260px] bg-gradient-to-br from-primary to-blue-dark">
    @if (prochaineSortie?.image) {
      <img
        [src]="$safeNavigationMigration(prochaineSortie?.image)"
        alt="Image de la prochaine sortie"
        class="absolute inset-0 w-full h-full object-cover opacity-60">
    }
    <div class="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>

    <div class="relative h-full p-6 flex flex-col justify-between text-white">
      <div>
        <span class="inline-flex items-center gap-1 text-[10px] font-raleway uppercase tracking-widest bg-white/20 backdrop-blur px-2 py-1 rounded-full">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Prochaine sortie
        </span>
      </div>
      @if (prochaineSortie) {
        <div>
          <h2 class="text-2xl md:text-3xl font-alice mb-2">{{ prochaineSortie.nom }}</h2>
          <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-raleway text-white/90">
            <span class="inline-flex items-center gap-1.5">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
              {{ formatDate(prochaineSortie.dateDebut) }} · {{ formatTime(prochaineSortie.dateDebut) }}
            </span>
            @if (prochaineSortie.lieu) {
              <span class="inline-flex items-center gap-1.5">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                {{ prochaineSortie.lieu }}
              </span>
            }
            <span class="inline-flex items-center gap-1.5">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
              {{ nbInscritsProchaineSortie }} présent.e.s
            </span>
          </div>
          @if (prochaineSortie.key) {
            <a [routerLink]="['/admin/evenements']"
              class="inline-flex items-center gap-2 mt-5 px-4 py-2 bg-white text-blue-dark text-sm font-raleway font-semibold rounded-lg hover:bg-gray-100 transition-colors">
              Gérer l'événement
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
            </a>
          }
        </div>
      } @else {
        <div>
          <h2 class="text-xl md:text-2xl font-alice mb-2">Aucune sortie programmée</h2>
          <p class="text-sm text-white/80 font-raleway">Ajoute un événement pour le faire apparaître ici.</p>
        </div>
      }
    </div>
  </div>

  <!-- Monthly chart -->
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <div class="flex items-center justify-between mb-4">
      <div>
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Activité annuelle</p>
        <h3 class="text-lg font-alice text-blue-dark">Sorties par mois</h3>
      </div>
    </div>
    <div class="flex items-end gap-1.5 h-32">
      @for (m of monthlyDistribution; track m) {
        <div class="flex-1 flex flex-col items-center justify-end h-full group">
          <span class="text-[10px] font-raleway text-gray-500 mb-1 opacity-0 group-hover:opacity-100 transition-opacity">{{ m.count }}</span>
          <div class="w-full rounded-t-md transition-colors"
            [class.bg-primary]="m.isCurrent"
            [class.bg-blue-200]="!m.isCurrent && m.count > 0"
            [class.bg-gray-100]="m.count === 0"
          [style.height.%]="barHeight(m.count)"></div>
        </div>
      }
    </div>
    <div class="flex gap-1.5 mt-2">
      @for (m of monthlyDistribution; track m) {
        <span class="flex-1 text-center text-[10px] font-raleway text-gray-400" [class.text-primary]="m.isCurrent" [class.font-semibold]="m.isCurrent">
          {{ m.label.charAt(0) }}
        </span>
      }
    </div>
  </div>
</div>

<!-- Upcoming events + Recent news -->
<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
  <!-- Upcoming events -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
      <div>
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">À venir</p>
        <h3 class="text-lg font-alice text-blue-dark">Prochaines sorties</h3>
      </div>
      <a routerLink="/admin/evenements" class="text-sm font-raleway font-semibold text-primary hover:text-secondary">Voir tout →</a>
    </div>
    <ul class="divide-y divide-gray-100">
      @for (e of prochainesSorties; track e) {
        <li class="px-5 py-3 hover:bg-gray-50 transition-colors">
          <div class="flex items-center gap-4">
            <div class="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-100 to-blue-200 flex flex-col items-center justify-center shrink-0">
              <span class="text-[10px] uppercase font-raleway font-semibold text-blue-700">{{ formatDate(e.dateDebut).split(' ')[1] }}</span>
              <span class="text-base font-alice text-blue-900 leading-none">{{ formatDate(e.dateDebut).split(' ')[0] }}</span>
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex items-center gap-2">
                @if (e.private) {
                  <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14v3m-3-6V7a3 3 0 116 0v4m-8 0h10c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1z"/></svg>
                }
                <p class="text-sm font-raleway font-semibold text-gray-800 truncate">{{ e.nom }}</p>
              </div>
              <p class="text-xs text-gray-500 truncate">{{ e.lieu }} · {{ formatTime(e.dateDebut) }}</p>
            </div>
          </div>
        </li>
      }
      @if (!loading && prochainesSorties.length === 0) {
        <li class="px-5 py-8 text-center text-sm text-gray-400 font-raleway">
          Aucune sortie prévue.
        </li>
      }
    </ul>
  </div>

  <!-- Recent news -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
      <div>
        <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Récent</p>
        <h3 class="text-lg font-alice text-blue-dark">Dernières actualités</h3>
      </div>
      <a routerLink="/admin/actualites" class="text-sm font-raleway font-semibold text-primary hover:text-secondary">Voir tout →</a>
    </div>
    <ul class="divide-y divide-gray-100">
      @for (a of recentesActualites; track a) {
        <li class="px-5 py-3 hover:bg-gray-50 transition-colors">
          <div class="flex items-center gap-4">
            @if (a.image) {
              <div class="w-12 h-12 rounded-lg overflow-hidden shrink-0 bg-gray-100">
                <img [src]="a.image" alt="" class="w-full h-full object-cover">
              </div>
            } @else {
              <div class="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center shrink-0">
                <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/></svg>
              </div>
            }
            <div class="min-w-0 flex-1">
              <p class="text-sm font-raleway font-semibold text-gray-800 truncate">{{ a.titre }}</p>
              <p class="text-xs text-gray-500 truncate">{{ formatDate(a.date) }}@if (a.auteur) {
                <span> · {{ a.auteur }}</span>
              }</p>
            </div>
          </div>
        </li>
      }
      @if (!loading && recentesActualites.length === 0) {
        <li class="px-5 py-8 text-center text-sm text-gray-400 font-raleway">
          Aucune actualité publiée.
        </li>
      }
    </ul>
  </div>
</div>
